import { render, staticRenderFns } from "./order-code-label.vue?vue&type=template&id=6d97e2aa&"
import script from "./order-code-label.vue?vue&type=script&lang=js&"
export * from "./order-code-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports